// components/IssuesTable.tsx
import React from "react";
import type { MinutesIssues } from "../../../services/minute";

type Props = {
  rows: MinutesIssues[];
};

const th: React.CSSProperties = {
  textAlign: "left",
  borderBottom: "1px solid #ddd",
  padding: "8px",
  background: "#f9f9f9",
  whiteSpace: "nowrap",
};
const td: React.CSSProperties = {
  borderBottom: "1px solid #eee",
  padding: "8px",
  verticalAlign: "top",
};
const tdRight: React.CSSProperties = {
  ...td,
  textAlign: "right",
  whiteSpace: "nowrap",
};
const tdCenter: React.CSSProperties = {
  ...td,
  textAlign: "center",
  whiteSpace: "nowrap",
};

const formatTimestamp = (unixSeconds?: number) => {
  if (!unixSeconds || Number.isNaN(unixSeconds)) return "-";
  const d = new Date(unixSeconds * 1000); // 秒→ms
  return new Intl.DateTimeFormat(undefined, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(d);
};

export const MinuteIssuesTable: React.FC<Props> = ({ rows }) => {
  if (!rows || rows.length === 0) {
    return <p style={{ color: "#666" }}>データがありません。</p>;
  }

  return (
    <div style={{ overflowX: "auto" }}>
      <table
        style={{ width: "100%", borderCollapse: "collapse", fontSize: 14 }}
      >
        <thead>
          <tr>
            <th style={th}>No.</th>
            <th style={th}>課題</th>
            <th style={th}>企業名</th>
            <th style={th}>商談日</th>
            <th style={th}>スコア</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r, idx) => (
            <tr key={r.minute_id ?? `${r.issue}-${idx}`}>
              <td style={tdCenter}>{idx + 1}</td>
              <td style={td}>{r.issue || "-"}</td>
              <td style={td}>{r.company_name || "-"}</td>
              <td style={td}>{formatTimestamp(r.meeting_timestamp)}</td>
              <td style={tdRight}>
                {typeof r.similarity_score === "number"
                  ? (r.similarity_score * 100).toFixed(2)
                  : "-"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
